import React from 'react';
import TopHeader from '../components/TopHeader';

const SuccessRdv = () => {
  return (
    <>
      <TopHeader btn={true}/>
      <div className="content-block">
        <div className="confirmation-container">
            <div className="svg-icon">
            <img src='/images/sucess.svg' alt="Success Icon" />
            </div>


            <h1 className="confirmation-title">Modification confirmée</h1>
            <p className="confirmation-description">
            Vous pouvez voir le détail de votre rendez-vous dans votre compte.
            </p>

            <button onClick={() => window.location.href = '/compte/rendez-vous'} className="btn-primary">
            Retourner à mon compte
            </button>
        </div>
      </div>
    </>
  );
};
export default SuccessRdv;
